<template>
  <Wrapper :client="client">
    <div class="mx-auto my-8 max-w-3xl px-4 sm:px-6 lg:px-8">
      <div v-if="activities.data.length > 0">
        <ul>
          <li
            v-for="(activity,key) in activities.data"
            :key="key">
            <div class="relative pb-8">
              <span
                v-if="key < activities.data.length-1"
                class="absolute left-5 top-5 -ml-px h-full w-0.5 bg-font-light"
                aria-hidden="true" />
              <div class="relative flex items-start space-x-3">
                <div class="relative">
                  <img
                    class="flex size-10 items-center justify-center rounded-full bg-font-light object-cover ring-8 ring-white"
                    :src="activity.creator.profile_photo_url"
                    :alt="activity.creator.name">

                  <span class="absolute -bottom-0.5 -right-1 rounded-tl bg-white px-0.5 py-px">
                    <ActivityIcon
                      :type="activity.type"
                      class="text-font-darkest" />
                  </span>
                </div>
                <div class="min-w-0 flex-1">
                  <div>
                    <div class="text-sm">
                      <Link
                        v-if="activity.project"
                        :href="route('projects.show', {project: activity.project})"
                        class="font-medium text-font-darkest">
                        {{ activity.creator.name }} in <span class="text-indigo-950 underline">{{ activity.project.name }}</span>
                      </Link>
                      <div
                        v-else
                        class="font-medium text-font-darkest">
                        {{ activity.creator.name }}
                      </div>
                    </div>
                    <p class="mt-0.5 text-sm text-font">
                      <date-time-formatter :date-time="activity.created_at" />
                    </p>
                  </div>
                  <div class="mt-2 text-sm text-font-dark">
                    <p>
                      {{ activity.comment }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <pagination
          :model="activities" />
      </div>
      <div
        v-else
        class="text-center text-sm">
        There are no activities registered on this client yet.
      </div>
    </div>
  </Wrapper>
</template>

<script>
import ActivityIcon from '@/Components/ActivityIcon.vue';
import DateTimeFormatter from '@/Components/DateTimeFormatter.vue';
import { Link } from '@inertiajs/vue3';
import Wrapper from './Wrapper.vue';
import Pagination from '../../ComponentsDeprecated/Pagination.vue';

export default {
  name: 'ActivityTab',
  components: {
    Link,
    DateTimeFormatter,
    ActivityIcon,
    Wrapper,
    Pagination,
  },

  props: {
    client: Object,
    activities: Object,
  },

  data() {
    return {};
  },

  watch: {},
  created() {},
  methods: {},
};
</script>

<style scoped>

</style>
